import { ApplicationConfig } from '@angular/core';
import { labConfig } from '@lab/lab.config';
import { applicationConfig } from './app/application.config';
import { environment } from './environments/environment';
import { mpsConfig } from './mps/mps.config';

export const globalConfig: ApplicationConfig = {
  providers: [
    ...mpsConfig.providers,
    ...applicationConfig.providers,
    ...(environment.mpsKit.enableLab ? labConfig.providers : []), //@MPS-KIT::TODO:add labConfig.providers
  ],
};
